export const isMobile = (device) => device === 'mobile';
export const isDesktop = (device) => device === 'desktop';
